import gql from 'graphql-tag';

const awardsListQuery = gql`
  query GetAwards {
    awards {
      displayText
      year
      description
      awardImage {
        urls
      }    
      link {
        url
      }
    }
  }
`;

export {
  awardsListQuery,
};